import type {
  CreatePromiseApiRequest,
  CreatePromiseApiResponse,
  LinkInvoiceRequest,
} from '@/hooks/useCreatePromiseData';

/**
 * Demo-mode fabricated response for creating a promise to pay.
 * Used as the demoFn for useCreatePromiseMutation.
 */
export async function createPromiseDemoResponse(data: CreatePromiseApiRequest): Promise<CreatePromiseApiResponse> {
  return {
    promiseId: String(Date.now()),
    customerId: data.customerId,
    customerName: 'Demo Customer',
    promiseDate: data.promiseDate,
    promisedAmount: data.promisedAmount,
    status: 'Active',
    confirmationMethod: 'Phone',
    createdBy: 'Demo User',
    assignedUserId: data.assignedUserId,
    assignedUserName: 'Demo User',
    createdAt: new Date().toISOString(),
    notes: data.notes,
  };
}

/**
 * Demo-mode fabricated response for linking an invoice to a promise.
 * Used as the demoFn for useLinkInvoiceMutation.
 */
export async function linkInvoiceDemoResponse({
  promiseId,
  invoice,
}: {
  promiseId: number;
  invoice: LinkInvoiceRequest;
}): Promise<{ promiseInvoiceId: number; promiseId: number } & LinkInvoiceRequest> {
  return { promiseInvoiceId: Date.now(), promiseId, ...invoice };
}
